import React from 'react';
import styles from './growthCurve.module.css';
import GrowthChart from './GrowthChart';

const LEGEND = {
    percentile: [['median', 'P50'], ['inner', 'P15 e P85'], ['outer', 'P3 e P97']],
    z: [['median', 'Escore-z 0'], ['inner', '-2 e +2'], ['outer', '-3 e +3']],
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/**
 * Gráfico de um indicador com legenda e avisos. Sem a curva quando nenhuma
 * medição cabe nela (idade fora da faixa da OMS ou cadastro incompleto):
 * nunca desenha ponto que a curva não cobre.
 *
 * `series`: saída de indicatorSeries; `sex`: 'male' | 'female' | null.
 */
const GrowthChartPanel = ({ series, sex, mode = 'percentile', markers = [], height }) => {
    const { indicator, points, window, total, outOfRange } = series;
    if (total === 0) {
        return <div className={styles.notice}>Nenhuma medição de {indicator.short.toLowerCase()} registrada.</div>;
    }

    const visibleMarkers = markers.filter((x) => x >= window[0] && x <= window[1]);
    const outOfRangeNotice = outOfRange > 0 && (
        <div className={styles.notice}>
            {plural(outOfRange, 'medição fora', 'medições fora')} da faixa de idade da curva. {indicator.beyond}
        </div>
    );

    if (!sex || points.length === 0) {
        return (
            <div className={styles.panel}>
                {outOfRangeNotice || (
                    <div className={styles.notice}>Sem curva: complete o nascimento e o sexo no cadastro do paciente.</div>
                )}
            </div>
        );
    }

    return (
        <div className={styles.panel}>
            <GrowthChart indicator={indicator} sex={sex} mode={mode} window={window} points={points} markers={visibleMarkers} height={height} />
            <div className={styles.legend}>
                {LEGEND[mode].map(([kind, label]) => (
                    <span key={kind} className={styles.legendItem}>
                        <span className={`${styles.legendLine} ${styles[kind]}`} />
                        {label}
                    </span>
                ))}
                <span className={styles.legendItem}>
                    <span className={styles.legendDot} />
                    Paciente
                </span>
                {visibleMarkers.length > 0 && (
                    <span className={styles.legendItem}>
                        <span className={styles.legendMarker} />
                        Medição craniana
                    </span>
                )}
                {points.some((point) => point.implausible) && (
                    <span className={styles.legendItem}>
                        <span className={`${styles.legendDot} ${styles.legendDotAlert}`} />
                        Muito fora da curva, confira o valor
                    </span>
                )}
            </div>
            {outOfRangeNotice}
        </div>
    );
};

export default GrowthChartPanel;
